import { STORE } from '@/constants'
import { AdminAPI } from '@/api'

const ADMIN = STORE.ADMIN

export default {
  namespaced: true,

  state: {
    list: null,
    obj: null,
    objInfo: null,
    editObj: null,
    rows: [],
    count: []
  },

  actions: {
    [ADMIN.LIST]: async ({ commit }, { objNm, page, perpage, search }) => {
      const result = await AdminAPI.list({ objNm, page, perpage, search })
      result.data.objNm = objNm
      commit(ADMIN.LIST, result.data)
    },

    [ADMIN.OBJ_INFO]: async ({ commit }, objNm) => {
      const result = await AdminAPI.info(objNm)
      if (!result) {
        throw new Error('Object Info Error')
      }

      if (result.data) {
        commit(ADMIN.OBJ_INFO, result.data)
      }
    },

    [ADMIN.NEW_OBJ]: async ({ commit }, objNm) => {
      commit(ADMIN.SELECT_ONE, { objNm, info: {} })
    },

    [ADMIN.GET_OBJ]: async ({ commit }, { objNm, uid }) => {
      const result = await AdminAPI.get({ objNm, uid })
      commit(ADMIN.SELECT_ONE, { objNm, data: result.data })
    }
  },

  getters: {
    [ADMIN.OBJ_INFO]: (state) => {
      return state.objInfo
    },

    [ADMIN.OBJ_DETAIL]: (state) => {
      return state.objDetail
    },

    [ADMIN.ROWS]: (state) => {
      return state.rows
    },

    [ADMIN.COUNT]: (state) => {
      return state.count
    }
  },

  mutations: {
    [ADMIN.OBJ_INFO] (state, data) {
      state.objInfo = data
    },

    [ADMIN.SELECT_ONE] (state, data) {
      state.detail = data
    },

    [ADMIN.LIST] (state, data) {
      state.rows[data.objNm] = data.list
      state.count[data.objNm] = data.count
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.store.js